import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";

const Otp = () => {
	const [initialTime, setInitialTime] = useState(120); // You can set this dynamically
	const [timeLeft, setTimeLeft] = useState(initialTime);

	useEffect(() => {
		setTimeLeft(initialTime); // Reset the timer whenever initialTime changes
	}, [initialTime]);

	useEffect(() => {
		if (timeLeft > 0) {
			const timer = setInterval(() => {
				setTimeLeft((prevTime) => prevTime - 1);
			}, 1000);

			return () => clearInterval(timer);
		}
	}, [timeLeft]);

	const formatTime = (seconds) => {
		const minutes = Math.floor(seconds / 60);
		const remainingSeconds = seconds % 60;
		return `${minutes}:${
			remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds
		}`;
	};

	const handleTimeChange = (event) => {
		const newTime = parseInt(event.target.value, 10);
		setInitialTime(newTime);
	};

	return (
		<>
			<div className="main-banner-heading1">
				<Header />
			</div>
			<section className="signin">
				<div className="container">
					<div className="row">
						<div className="col-lg-6 mx-auto">
							<div className="main-bg-signin">
								<h2 className="main-heading level-2 text-center mt-3 mb-3 main-heading-font dark-color wow animate__animated animate__zoomIn">
									Forgot Password{" "}
								</h2>
								<div>
									<h4 className="primary-regular-font text-center mt-3 level-7 text-decoration-none mb-0">
										We’ve sent a 4-digit OTP via email. It will expire in
										<span className="primary-medium-font timing">
											{" "}
											{formatTime(timeLeft)}
										</span>
									</h4>
									<div className="text-center mt-3 d-none">
										<label htmlFor="timeInput">
											Set OTP Expiry Time (seconds):{" "}
										</label>
										<input
											id="timeInput"
											type="number"
											value={initialTime}
											onChange={handleTimeChange}
											className="primary-regular-font"
										/>
									</div>
								</div>
								<div className="row mt-4">
									<div className="col-lg-3  mt-3">
										<div class="form-group">
											<input
												type="number"
												className="form-control"
												id="firstName"
												placeholder="0"
											/>
										</div>
									</div>
									<div className="col-lg-3  mt-3">
										<div class="form-group">
											<input
												type="number"
												className="form-control"
												id="firstName"
												placeholder="0"
											/>
										</div>
									</div>
									<div className="col-lg-3  mt-3">
										<div class="form-group">
											<input
												type="number"
												className="form-control"
												id="firstName"
												placeholder="0"
											/>
										</div>
									</div>
									<div className="col-lg-3  mt-3">
										<div class="form-group">
											<input
												type="number"
												className="form-control"
												id="firstName"
												placeholder="0"
											/>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col-lg-12">
										<Link
											class="resend-otp main-heading-font dark-color w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
											to="/create-new-password"
										>
											Resend OTP Code
										</Link>
									</div>
								</div>
								<div className="row">
									<div className="col-lg-12">
										<Link
											class="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
											to="/create-new-password"
										>
											<span class="bg-wrapper w-100">Submit</span>
										</Link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default Otp;
